// Use the same helper as Babel to avoid bundle bloat.
import { install } from "@material-ui/styles";

install();
